// extracted by mini-css-extract-plugin
module.exports = {"component":"project-blurb-module--component--SxZGL","mapp":"project-blurb-module--mapp--1oY8q","linkOut":"project-blurb-module--linkOut--1OYxT"};